<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int} from '../../../validators.js';
    import {network, parameter} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from "../../../config";
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();

    export let put_item = async (item) => {
        let polotno = [
            'Сетка москитная, Максимальный обзор',
            'Сетка москитная, PPE',
            'Сетка москитная, АнтиМОШКА',
            'Сетка москитная, Антикошка серебро',
            'Сетка москитная, алюминиевая',
            'Сетка москитная, антикошка белое',
            'Сетка москитная, антикошка черное',
            'Сетка москитная, гипоаллергенная',
            'Сетка москитная, стандарт'
        ];

        if (item) {
            let title = item.title.split(' ', 3);

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            ind1 = item.title.includes('без перемычки') ? 'Нет' : 'Есть';
            ind2.set(title[2]);
            ind3 = polotno.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));

            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch($ind2);
            change();
        }
    };
    export let set_item;
    export let add_montage;
    export let calc;
    export let options;

    const color = options.color || {
        'Белый': 'Белый',
        'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
        'Антрацит':'Антрацит',
        'Цветной': 'Цветной',

    };


    const fixprecision = (value) => Math.ceil(value * precision) / precision;
    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Дверная', '', color);
        let options = await network.fetch_ind('Дверная');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }
    let fetchData = fetch();

    let
        width = parameter('width', '800'),
        height = parameter('height', '2000'),
        ind1 = 'Импост 42', // перемычка
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Сетка москитная, стандарт', // полотно

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    const changeInd2 = () => {
        fetchData = fetch($ind2)
    };
    const changeHeight = _.debounce(() => {
        if ($height > 1400 && ind1 !== 'Есть') {
            ind1 = 'Есть';
            toastbox('toast-ind1', 3000);
        }
    }, 1000);

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height
        ;

        let dimensions = [w, h].join('×');
        let result = {
            type: 'Дверная',
            name: 'Дверная',
            subname: [
                w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой '+ ind1,

            ].join(''),
            title: [
                'Дверная', ' ', w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой '+ ind1,

            ].join(''),
            params: {
                ind1: ind1,
                ind2: $ind2,
                ind3: ind3,
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 43,
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (
                name.includes('профиль м/двери 42')
            ) {
                kolvo = ((w  * 2 + h * 2) / 1000).toFixed(3);
            }

            if (name.includes('угол')) {

                    kolvo = (4).toFixed(3);

            }

            if (name.includes('мпост м/двери 42мм')) {
                if (ind1 === 'Импост 42') {
                    kolvo = ((w-42-42) / 1000).toFixed(3);
                }
            }

            if (name.includes('перемычка мс')) {
                if (ind1 === 'Стандарт') {
                    kolvo = ((w-42-42) / 1000).toFixed(3);
                }
            }

            if (name.includes('оединитель импоста')) {
                if (ind1 === 'Импост 42') {
                    kolvo = (2).toFixed(3);
                }
            }

            if (name.includes('крепление')) {
                if (ind1 === 'Стандарт') {
                    kolvo = (2).toFixed(3);
                }
            }


            if (name.includes('ручка')) {
                kolvo = (2).toFixed(3);
            }
            if (name.includes('прессшайба')) {
                kolvo = (8).toFixed(3);
            }

            if (name.includes('петля')) {
                kolvo = (3).toFixed(3);
            }



            if (name.includes('фиксирующий')) {
                    kolvo = ((w  * 2 + h * 2) / 1000).toFixed(3);
            }


            if (
                (
                    name.includes('сетка москитная')
                ) && name.indexOf(ind3.toLowerCase()) >= 0
            ) {
                kolvo = (w * h / 1000000).toFixed(3);
            }

            if (name.includes('комплект креплений') && ind3.toLowerCase() === 'наносетка') {
                kolvo = (1).toFixed(3);
            }


            if (name.includes('работа пс')) {
                if (
                    ind3.toLowerCase().includes('антикошка') ||
                    ind3.toLowerCase().includes('алюминиевая') ||
                    ind3.toLowerCase().includes('гипоаллергенная')

                ) {
                    kolvo = (1).toFixed(3);
                }
            } else if (name.includes('работа')) {
                if (
                    ind3.toLowerCase().includes('стандарт') ||
                    ind3.toLowerCase().includes('ppe') ||
                    ind3.toLowerCase().includes('антимошка') ||
                    ind3.toLowerCase().includes('максимальный обзор') ||
                    ind3.toLowerCase().includes('нет')
                ) {
                    kolvo = (1).toFixed(3);
                }
            }



            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    quantity,
                    price,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
  <!--<pre>{JSON.stringify(data , null, 10)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change} on:mousemove|once={change}>
        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Москитное полотно</label>
                        <select class="form-control form-select" bind:value={ind3}>
                            {#each _.sortBy(data.edIzmer['кв.м'], 'name') as item}
                                {#if item.flag == 1}
                                    <option value="{item.name}">{item.name.replace('Сетка москитная,', '').trim()}</option>
                                {/if}
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет</label>
                        <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                            {#each Object.entries(color) as [value]}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ширина, мм</label>
                        <input type="number" class="form-control" step="10" min="250" max="2400" bind:value={$width} >
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Высота, мм</label>
                        <input type="number" class="form-control" step="10" min="250" max="2400" bind:value={$height} on:change={changeHeight} use:validate_int={$height}>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Перемычка</label>
                        <select class="form-control form-select" bind:value={ind1}>
                            <option value="Импост 42">Импост 42</option>
                            <option value="Стандарт">Стандарт</option>
                            <option value="Нет">Нет</option>
                        </select>
                    </div>
                </div>
            </div>

        </div>


        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}


